// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"50631eb5","115":"fdcc9552","167":"e47b5f46","783":"b90808ba"}[chunkId] + ".chunk.js";
};